import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_MARKET_INDICATORS } from '../graphql/queries/marketIndicators';
import AltcoinSeasonIndicator from './indicators/AltcoinSeasonIndicator';
import BtcDominanceIndicator from './indicators/BtcDominanceIndicator';
import FearAndGreedIndicator from './indicators/FearAndGreedIndicator';
import MarketCapIndicator from './indicators/MarketCapIndicator';

const MarketIndicators = () => {
  const { loading, error, data } = useQuery(GET_MARKET_INDICATORS, {
    errorPolicy: 'all',
  });

  if (loading) {
    return (
      <div className="flex justify-center items-center h-8">
        <div className="animate-spin h-4 w-4 border-t-2 border-b-2 border-blue-500 rounded-full"></div>
      </div>
    );
  }

  const { 
    altcoinSeasonScore,
    altcoinSeasonStatus,
    btcDominance,
    fearAndGreedScore,
    fearAndGreedStatus,
    marketCap,
    marketCapChange24h,
  } = data?.marketIndicators || {};

  const hasAnyData = marketCap || btcDominance || altcoinSeasonScore || fearAndGreedScore;

  if (error && !hasAnyData) {
    return (
      <div className="flex items-center gap-2 text-[11px] sm:text-xs text-gray-400">
        <span title={error.message}>Market data unavailable</span>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center gap-3 sm:gap-6 text-[11px] sm:text-xs whitespace-nowrap">
      {marketCap !== undefined && (
        <MarketCapIndicator 
          marketCap={marketCap}
          marketCapChange24h={marketCapChange24h}
        />
      )}
      {altcoinSeasonScore !== undefined && (
        <AltcoinSeasonIndicator 
          score={altcoinSeasonScore} 
          status={altcoinSeasonStatus}
        />
      )}
      {btcDominance !== undefined && (
        <BtcDominanceIndicator 
          dominance={btcDominance}
        />
      )}
      {fearAndGreedScore !== undefined && (
        <FearAndGreedIndicator 
          score={fearAndGreedScore} 
          status={fearAndGreedStatus}
        />
      )}
      <a
        href="https://www.bitcoinmagazinepro.com/charts/mvrv-zscore/"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center whitespace-nowrap text-white no-underline hover:opacity-80"
        title="MVRV Z-Score chart"
      >
        <span className="mr-2 font-medium hidden sm:inline">BTC MVRV Z-Score</span>
      </a>
      {error && hasAnyData && (
        <span 
          className="text-yellow-500 cursor-help" 
          title={`Some data unavailable: ${error.message}`}
        >
          ⚠
        </span>
      )}
    </div>
  );
};

export default MarketIndicators; 